// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"ec42a7b9","453":"861fb37d"}[chunkId] + ".chunk.js";
};